export default __webpack_public_path__ + "static/m-blog4-33ac572b21a6dfa5fcf772ac229fefd3.jpg";